import { bigIntToHex } from '@web3-onboard/common';
import { configuration } from './configuration.js';
import { state } from './store/index.js';
import { gweiToWeiHex, networkToChainId, toHexString } from './utils.js';
const ACTIONABLE_EVENT_CODES = ['txPool'];
const VALID_GAS_NETWORKS = ['main', 'matic-main'];
const WALLETS_SUPPORT_REPLACEMENT = [
    'Ledger',
    'Trezor',
    'Keystone',
    'KeepKey',
    `D'CENT`
];
export const actionableEventCode = (eventCode) => ACTIONABLE_EVENT_CODES.includes(eventCode);
export const validGasNetwork = (network) => VALID_GAS_NETWORKS.includes(network);
export const walletSupportsReplacement = (wallet) => wallet && WALLETS_SUPPORT_REPLACEMENT.includes(wallet.label);
export async function replaceTransaction({ type, wallet, transaction }) {
    const { from, input, value, to, nonce, gas: gasLimit, network } = transaction;
    const chainId = networkToChainId[network];
    const { gasPriceProbability } = state.get().notify.replacement;
    const { gas } = configuration;
    if (!gas)
        return;
    // get gas price
    const [gasResult] = await gas.get({
        chains: [networkToChainId[network]],
        endpoint: 'blockPrices'
    });
    const { maxFeePerGas, maxPriorityFeePerGas } = gasResult.blockPrices[0].estimatedPrices.find(({ confidence }) => confidence ===
        (type === 'speedup'
            ? gasPriceProbability === null || gasPriceProbability === void 0 ? void 0 : gasPriceProbability.speedup
            : gasPriceProbability === null || gasPriceProbability === void 0 ? void 0 : gasPriceProbability.cancel)) || {};
    if (!maxFeePerGas || !maxPriorityFeePerGas)
        return;
    const maxFeePerGasWeiHex = gweiToWeiHex(maxFeePerGas);
    const maxPriorityFeePerGasWeiHex = gweiToWeiHex(maxPriorityFeePerGas);
    // Some wallets do not like empty '0x' val
    const dataObj = input === '0x' ? {} : { data: input };
    return wallet.provider.request({
        method: 'eth_sendTransaction',
        params: [
            Object.assign({ type: '0x2', from, to: type === 'cancel' ? from : to, chainId: parseInt(chainId), value: bigIntToHex(BigInt(value)), nonce: toHexString(nonce), gasLimit: toHexString(gasLimit), maxFeePerGas: maxFeePerGasWeiHex, maxPriorityFeePerGas: maxPriorityFeePerGasWeiHex }, dataObj)
        ]
    });
}
